export default __webpack_public_path__ + "static/img-mentha-partners-6eb68dc7759730ce872e3abce75595a0.png";